import React, { useState } from "react";

import BedTypeAddition from "./BedTypeAddition";
import BedTypeList from "./BedTypeList";

/**
 * Ward Management — add form on top, list below, same as the User Management
 * and Doctor Management screens. See BedManagement for why the refresh counter
 * lives here instead of App.js's shared `refreshList`.
 *
 * The UI calls these wards; the backend entity is still a bed type
 * (ipd_bedtype/), so the API and prop names keep that wording.
 */
function BedTypeManagement() {
  const [refreshList, setRefreshList] = useState(0);

  return (
    <div>
      <BedTypeAddition updateList={() => setRefreshList((n) => n + 1)} />
      <BedTypeList refreshList={refreshList} />
    </div>
  );
}

export default BedTypeManagement;
